// src/composables/usePermissions.js
import { computed } from 'vue';
import { useAuth } from "@/services/auth.js"; // ← Ajuste o caminho

export function usePermissions() {
  const auth = useAuth();
  
  const userLevel = computed(() => auth.user?.level);
  const tenantRule = computed(() => auth.tenant?.rule); // 0=adm, 1=user, 2=operador
  
  const isAdmin = computed(() => tenantRule.value === 0);
  const isUser = computed(() => tenantRule.value === 1);
  const isOpeto = computed(() => tenantRule.value === 2);
  
  const hasLevel = (...levels) => {
    // Aceita tanto a string nova (adm) quanto a antiga (admin/opeto) para compatibilidade
    const mapping = { admin: 'adm', opeto: 'operador' };
    const normalizedLevels = levels.map(l => mapping[l] || l);
    return normalizedLevels.includes(userLevel.value);
  };

  
  const can = (permission) => {
    const permissions = {
      'users.create': ['admin'],
      'users.edit': ['admin'],
      'users.delete': ['admin'],
      'users.list': ['admin'],
      'reports.view': ['admin', 'opeto'],
      'profile.edit': ['admin', 'user', 'opeto'],
    };
    
    return permissions[permission]?.includes(userLevel.value) || false;
  };
  
  return {
    user: auth.user,  // ← Retorna o computed da store
    userLevel,
    isAdmin,
    isOpeto,
    isUser,
    hasLevel,
    can
  };
}